

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

// set Date FORMAT
export const DATE_FORMAT = 'DD-MMM-YYYY';


/// GET IP  ADDRESS
const responseip = await fetch("https://api.ipify.org?format=json");
const data = await responseip.json();
const ip = data.ip;
export const IP=ip + "";




//SET copyrights

export function Copyright(props) {
    return (
      <Typography variant="body2" color="textSecondary" align="center" {...props}>
        {"Copyright © "}
        <Link color="inherit" href="https://sriyansh.co.in">
          Sriyansh Computers, Gorakhpur
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }
  

  //SET developers
  export function Developer(props) {
    return (
      <Typography variant="body2" color="textSecondary" align="center" {...props}>
        {"Software Developed by "}
        <Link color="inherit" href="https://sriyansh.co.in">
          Sriyansh Computers
        </Link>{" "}
      </Typography>
    );
  }
  

  export const USER_RIGHTS = {
    SUPER_ADMIN:0,
    ADMIN: 1,
    ENTRY_USER: 2,
    MIS_USER:3,
    


}

export function getCurrentLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        }
      );
    }
  });
}

//export const API_BASE_URL = 'https://ccms.sriyansh.co.in/phpapi';
//export const API_BASE_URL = 'https://ccm.srv851107.hstgr.cloud/phpapi';

export const API_BASE_URL = 'https://ccm.sriyansh.com/phpapi';

export const DISPLAY_PAGE_SIZE=10;
export async function getLocationByIP() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return {
      // latitude: data.latitude,
      // longitude: data.longitude,
      // city: data.city,
      // region: data.region,
      // country: data.country_name,
      // ip: data.ip,
      // data: data.data,
      data: data,
    };
  } catch (error) {
    throw new Error('Unable to fetch IP-based location');
  }
}
